module.exports = __webpack_public_path__ + "img/invoices.c1e04893.svg";